import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
//own
import { createSx } from '../../../../../../../../../../utils';
import EllipsedTypography from '../../../../../../../../../Tooltip/EllipsedTypography';
import IconButton from '../../../../../../../../../IconButton';
import { Attachment } from '../../../../../../../..';
import Button from '../../../../../../../../../Button';
import { attachmentDetailsSectionStyles } from '../../../shared/styles';

const sx = createSx(attachmentDetailsSectionStyles);

interface Props<T extends Attachment, > {
  activeAttachment: T;
  handleClose: () => void;
  AttachmentDetails?: React.ElementType;
  children: React.ReactNode;
}

const MobileAttachmentDetailsSection = <T extends Attachment, >({ children, activeAttachment, handleClose, AttachmentDetails }: Props<T>) => {
  const { t } = useTranslation();
  const [showDetails, setShowDetails] = useState<boolean>(false);

  return (
    <Stack data-test-id='attachment-details-section' sx={sx.mobileWrapper}>
      <Stack sx={sx.header} data-test-id='attachment-details-section-header'>
        <EllipsedTypography variant='h5' testID='attachment-name'>{activeAttachment.name}</EllipsedTypography>
        <IconButton
          title={t('close')}
          onClick={handleClose}
          data-test-id='close-attachment-details-btn'>
          <CloseIcon />
        </IconButton>
      </Stack>
      <Stack sx={sx.mobileWrapperChildrenContainer}>
        {children}
        {AttachmentDetails &&
          <>
            <Button
              variant='text'
              size='large'
              startIcon={showDetails ? <KeyboardDoubleArrowDownIcon /> : <KeyboardDoubleArrowUpIcon />}
              onClick={() => setShowDetails(prev => !prev)}
              testID='attachment-details-btn'
            >
              {showDetails ? t('hideDetails') : t('showDetails')}
            </Button>
            <Collapse
              in={showDetails}
              sx={sx.collapse}
              onWheel={(e) => e.stopPropagation()}
            >
              <AttachmentDetails attachment={activeAttachment} />
            </Collapse>
          </>
        }
      </Stack>
    </Stack>
  );
};

export default MobileAttachmentDetailsSection;